module.exports = __webpack_public_path__ + "static/media/feedbackUnderReview_animation.da1cfc17.gif";